import React from 'react'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { defaultFunction } from '../../utilities/utilities'
import { removeDatefromDateTime } from '../../utilities/FormatDate'
import { connect } from 'react-redux'


function TableButtonGenerator(props) {
  const {
    exitConfirmation = defaultFunction,
  } = props
  const { t } = useTranslation()
  const { row } = props
  
  if (row.exit_time) return removeDatefromDateTime(row.exit_time)
  return (
    <Button
      sx={{ width: '180px' }}
      size='small'
      variant='contained'
      onClick={() => exitConfirmation(row)}
      >
        {t('exit confirmation')}
      </Button>
  )
}


const mapStateToProps = state => {
  return {
    isOnline: state.utilities.isOnline
  }
}

export default connect(mapStateToProps)(TableButtonGenerator)